import toolbar from './ertNgWizardToolbar.component';

const wizardToolbarComponent = angular.module('app.common.wizardToolbar', [])
    .component('ertNgWizardToolbar', toolbar)
    .name;

export default wizardToolbarComponent;
